import Cookies from "js-cookie";
import { checkLetsLaunchAccess } from "../client/api";
import { setSsoCookie, getSafeRedirectTarget } from "./ssoCookie";

// Post-login steps for the MFA page; mirrors Login.tsx's handleLogin.
export const completeLogin = async (
  data: { user: any; token: string; refreshToken?: string },
  {
    setUser,
    setCurrentWorkspace,
    navigate,
    redirectParam,
  }: {
    setUser: (user: any) => void;
    setCurrentWorkspace: (workspace: any) => void;
    navigate: (path: string) => void;
    redirectParam: string | null;
  }
) => {
  const { user, token, refreshToken } = data;

  localStorage.setItem("token", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("userId", user._id);
  setSsoCookie(token);
  setUser(user);

  // Same as the Google callback: no organization yet -> complete profile first.
  if (!user.organization) {
    navigate(
      `/complete-profile?userId=${user._id}&token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken || "")}`
    );
    return;
  }

  setCurrentWorkspace(user.ownedWorkspaces?.[0]);
  Cookies.set(
    "authInfo",
    JSON.stringify({
      userId: user._id,
      organizationKey: user.organization.organizationKey,
      letsLaunchAccess: user.organization.letsLaunchAccess,
    }),
    {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path: "/",
      secure: true,
      sameSite: "strict",
      expires: 5,
    }
  );

  const redirectTarget = getSafeRedirectTarget(redirectParam);
  if (redirectTarget) {
    window.location.href = redirectTarget;
    return;
  }

  const invitationUrl = localStorage.getItem("invitationUrl");
  if (invitationUrl) {
    localStorage.removeItem("invitationUrl");
    navigate(invitationUrl);
    return;
  }

  const hasLetsLaunchAccess = await checkLetsLaunchAccess(user.organization.organizationKey);
  const APP_URLS: Record<string, string> = {
    zapflow: process.env.REACT_APP_ZAPFLOW_URL || "https://zapflow.letslaunch.io",
    farmsystem: process.env.REACT_APP_FARMSYSTEM_URL || "https://farmsystem.letslaunch.io",
  };
  const otherApps = [
    user.zapflowAccess && "zapflow",
    user.farmSystemAccess && "farmsystem",
  ].filter(Boolean) as string[];
  const totalAccessCount = (hasLetsLaunchAccess ? 1 : 0) + otherApps.length;

  if (!hasLetsLaunchAccess && otherApps.length === 1) {
    window.location.href = APP_URLS[otherApps[0]];
  } else if (totalAccessCount > 1) {
    navigate("/app-selection");
  } else {
    navigate("/");
  }
};
